/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react'
import DynamicAppointments from './DynamicAppointments'

const Appointments: React.FunctionComponent = () => {
    return (
        <div>
            <div className='flex justify-between mb-4 items-center'>
                <h2>Afspraken</h2>
            </div>
            <div className='border-full shadow-sm bg-white rounded-xl h-auto flex-grow relative flex flex-col'>
                <DynamicAppointments canSearch />
            </div>
        </div>
    )
}

export default Appointments
